<template>
    <div class="explain-box">
        <div class="caption" v-html='explainData.caption'></div>
        <div class="explain-item-box">
            <div class="itembox" v-for='(item,index) in explainData.data' :key='index'>
                <div class="imagebox" :style='{backgroundImage:"url("+item.imgurl+")"}'></div>
                <div class="center-box">
                    <h3 class="item-caption">{{item.caption}}</h3>
                    <div class="title">{{item.title}}</div>
                    <p class="center">{{item.center}}</p>
                    <p class="translate">{{item.translate}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Explain',
        data() {
            return {
                explainData: {
                    caption: '一个定制化网站，不仅高逼格,<br/>而且通过我们的编写和设计可以带来更多转化。<br/>....',
                    data: [
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/william-iven-jrh5lAq-mIs-unsplash.jpg',
                            caption: '前期调研与分析',
                            title: 'Preliminary investigation and analysis',
                            center: '优秀的网站始于研究。 我们的团队（项目经理，写手，设计师和开发人员）将根据您的受众群体，竞争和目标研究并制定制胜计划。',
                            translate: 'A great website starts with research. Our team (Project Manager, Writer, Designer, & Developer) will research and create a winning plan based on your audience, competition, and goals.'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/%E8%92%99%E7%89%88%E7%BB%84%2095.jpg',
                            caption: '售后服务',
                            title: 'after-sales service',
                            center: '一旦我们的网站通过了质量检查和测试，您的网站就可以与世界分享。 该网站上线后，我们的支持不会停止。 网站答疑和培训始终是免费的。',
                            translate: "Once it's passed our QA & Testing your website is ready to share with the world. Our support does not stop once the site is live. We're here to answer questions, and training is always free."
                        }
                    ]
                }
            }
        }
    }
</script>
<style scoped>
    .explain-box {
        padding: 165px 0 201px 0;
    }

    .caption {
        font-size: 40px;
        font-weight: bold;
        line-height: 56px;
        text-align: center;
        color: rgba(28, 28, 28, 1);
    }

    .explain-item-box {
        display: grid;
        height: 562px;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 60px;
        margin-top: 174px;
    }

    .itembox {
        position: relative;
    }

    .imagebox {
        position: absolute;
        right: 0;
        width: 90%;
        height: 90%;
        background: transparent no-repeat center center;
        background-size: cover;
    }

    .center-box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 70%;
        min-height: 406px;
        padding: 60px;
        background-color: rgba(51, 51, 51, .89);
    }

    .item-caption {
        font-size: 24px;
        color: #ffffff;
        margin-bottom: 12px;
        font-weight: bold;
    }

    .title {
        font-size: 14px;
        color: #ffffff;
        font-weight: 400;
    }

    .center {
        font-size: 14px;
        font-weight: 400;
        line-height: 142%;
        color: rgba(255, 255, 255, 1);
        margin-top: 40px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ffffff;
        margin-bottom: 10px;
    }

    .translate {
        font-size: 14px;
        font-weight: 400;
        line-height: 114%;
        color: rgba(153, 153, 153, 1);
    }

    @media(max-width: 995px) {
        .explain-box {
            padding: 0;
        }

        .caption {
            font-size: 24px;
            line-height: 140%;
        }

        .imagebox {
            display: none;
        }

        .center-box {
            padding: 5%;
            position: static;
            width: 100%;
            min-height: 100%;
            height: 100%;
        }

        .explain-item-box {
            display: grid;
            height: auto;
            grid-template-columns: 1fr;
            grid-column-gap: auto;
            margin-top: 0;
        }

        .center {
            font-size: 16px;
            margin-top: 5%;
            margin-bottom: 5%;
        }
    }

    /* @media(max-width: 1023px) {
        .caption {
            font-size: 60px;
            line-height: 140%;
        }

        .explain-item-box {
            display: grid;
            height: 2000px;
            grid-template-columns: 1fr;
            grid-row-gap: 10%;
        }

        .imagebox {
            width: 80%;
            height: 100%;
        }

        .center-box {
            width: 80%;
            min-height: auto;
        }
        .item-caption {
            font-size: 75px;
        }

        .title {
            font-size: 40px;
        }

        .center {
            font-size: 50px;
        }

        .translate {
            font-size: 50px;
        }

    }

    @media(max-width: 320px){
        .explain-item-box {
            grid-row-gap: 30%;
        }
        .caption {
            margin-bottom: 30%;
        }
    }
    @media(max-width: 436px){
        
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/explain.vue